import React from 'react';

export const TarjetaPresupuestos = (props) => {
	/* Destructuring the props object. */
	const {
		imagenPaciente,
		nombrePaciente,
		telefono,
		direccion,
		localidad,
		precio,
		servicio,
		fecha,
		horasMin,
		activarPresupuestos,
		TipoNotificaciones,
		id,
		cancelarServicio,
		eliminarServicio,
		confirmar,
		rechazarServicio,
		fechaPaciente,
	} = props;

	return (
		<div className='TarjetaSuperiorPresupuestos'>
			<div className='TarjetaSuperiorDerPresupuestos'>
				<div className='fotoTarjetaPresupuestos centrador'>
					<img src={imagenPaciente} />
				</div>
				<div className='nombreDescripcionTarjetaPresupuestos'>
					<div className='nombreTarjetaPresupuestos'>
						<h4>{nombrePaciente}</h4>
					</div>
					<div className='descripcionTarjetaPresupuestos'>
						<b>Fecha de nacimento:</b> {fechaPaciente}
					</div>
					<div className='descripcionTarjetaPresupuestos'>
						<b>Teléfono: </b> {telefono}
					</div>
					<div className='descripcionTarjetaPresupuestos'>
						<b>Población: </b> {localidad.nombre}
					</div>
					<div className='descripcionTarjetaPresupuestos'>
						<b>Dirección:</b> {direccion}
					</div>
				</div>
			</div>
			<div className='TarjetaSuperiorIzqPresupuestos'>
				<div className='precioTarjetaPresupuestos'>
					<h4>{servicio}</h4>
				</div>
				<div className='infoTarjetaPresupuestos'>
					<b>Precio:</b>
					{precio + ' €'}
				</div>
				<div className='infoTarjetaPresupuestos'>
					<b>Fecha:</b>
					{fecha}
				</div>
				<div className='infoTarjetaPresupuestos'>
					<b>Duración:</b>
					{horasMin + ' minutos'}
				</div>
			</div>
			<div className='buttons-presupuesto'>
				{
					TipoNotificaciones[0] === 'buttonNotificacionesActive' ||
					TipoNotificaciones[1] === 'buttonNotificacionesActive' ? (
						<div className='contentBodyCancelarPresupuestos'>
							<div className='servicio-aceptado'>
								<div>Activado</div>
							</div>
						</div>
					) : TipoNotificaciones[2] === 'buttonNotificacionesActive' ? (
						<>
							<div
								className='button'
								onClick={() => activarPresupuestos(id)}
							>
								<b>Activar</b>
							</div>
							<div className='contentBodyCancelarPresupuestos'>
								<div
									className='button borrarCuenta'
									onClick={() => cancelarServicio(id)}
								>
									<div>
										<b>Rechazar</b>
									</div>
								</div>
							</div>
						</>
					) : (
						TipoNotificaciones[3] === 'buttonNotificacionesActive' && (
							<div className='contentBodyCancelarPresupuestos'>
								<div
									className='button borrarCuenta'
									onClick={() => eliminarServicio(id)}
								>
									<div>
										<b>Eliminar</b>
									</div>
								</div>
							</div>
						)
					)
					/*
(TipoNotificaciones[1] === "buttonNotificacionesActive")
&& <div className='activarPresupuesto button'
    onClick={() => setmodalActivar(true)}
><b>Activar</b></div>
        && 
            : ((TipoNotificaciones[0] === "buttonNotificacionesActive")) || ((TipoNotificaciones[1] === "buttonNotificacionesActive"))
    <div className='contentBodyCancelarPresupuestos'>
        <div className='servicio-aceptado'
        >
        <div>Activado</div>
        </div>
    </div>
    : (TipoNotificaciones[3] === "buttonNotificacionesActive")
    && <div className='contentBodyCancelarPresupuestos'>
        <div className='button borrarCuenta'
        onClick={() => eliminarServicio(id)}>
            <div><b>Eliminar</b></div>
        </div>
    </div>
*/
				}
			</div>
		</div>
	);
};
